import { BoxProps } from '@mui/material';

import { Box, Typography, theme } from '@sbv-clients/ui-shared';

interface LegendProps {
  title: string;
  backgroundColor: BoxProps['bgcolor'];
}

const Legend = ({ title, backgroundColor }: LegendProps) => {
  return (
    <Box display="flex" fontSize="medium">
      <Box p={3} mr={1} ml={2} bgcolor={backgroundColor} borderRadius={0.5} />
      <Typography fontSize="medium">{title}</Typography>
    </Box>
  );
};

const Legends = () => {
  return (
    <Box display="flex" alignItems="center" columnGap={8}>
      <Box fontSize="large">Utilization</Box>
      <Legend title="Optimal" backgroundColor={theme.custom?.legendOptimal} />
      <Legend title="Under" backgroundColor={theme.custom?.legendUnder} />
      <Legend title="Over" backgroundColor={theme.custom?.legendOver} />
      <Typography fontSize="medium">Ppl</Typography>
      <Typography fontSize="medium">Hrs</Typography>
    </Box>
  );
};

export default Legends;
